import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import Encryption from '../utils/encrypt';
import { AuthService } from '../services/auth.service';
import { AuthGroup } from '../models/authorization.types';
import { EncryptionService } from '../services/encryption.service';

@Injectable()
export class RouteGuard implements CanActivate, CanActivateChild {
    constructor(
        private _authService: AuthService,
        private _router: Router,
        private toastr: ToastrService,
        private _crypt: EncryptionService,
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
            return this.hasRequiredPermission(next.data['auth']);
    }

    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
            return this.hasRequiredPermission(next.data['auth']);
    }


    protected hasRequiredPermission(authGroup: AuthGroup): Promise<boolean> | boolean {
        // If user’s permissions already retrieved from the API
        if (this._authService.permissions) {
            if (authGroup) {
                return this._authService.hasPermission(authGroup);
            } else {
                return this._authService.hasPermission(null);
            }
        } else {
            // Otherwise, must request permissions from the API first
            const id = this._crypt.getItem('user').id;
            const promise = new Promise<boolean>((resolve, reject) => {
                this._authService.initializePermissions(id)
                    .then(() => {
                        if (authGroup) {
                            resolve(this._authService.hasPermission(authGroup));
                       } else {
                            resolve(this._authService.hasPermission(null));
                        }
                    }).catch(() => {
                        resolve(false);
                    });
            });
            return promise;
        }
    }
}
